import type { AdminApiPublishedVersion } from "@repo/app-types/entities/teammateAgent";
import type { FC } from "react";
import {
  useGetTeammateAgentVersionsQuery,
  useRollbackTeammateAgentMutation,
} from "../../api/entities/teammateAgent.js";
import { VersionHistoryPopover } from "../versionHistory/versionHistoryPopover.js";

export interface VersionHistoryButtonProps {
  teammateAgentId: string;
  isDisabled?: boolean;
  onRollbackComplete?: () => void;
}

export const VersionHistoryButton: FC<VersionHistoryButtonProps> = ({
  teammateAgentId,
  isDisabled,
  onRollbackComplete,
}) => {
  const { data: versions, isLoading } =
    useGetTeammateAgentVersionsQuery(teammateAgentId);

  const [rollback, { isLoading: isRollingBack }] =
    useRollbackTeammateAgentMutation();

  const handleRollback = async (version: AdminApiPublishedVersion) => {
    await rollback({
      teammateAgentId,
      configRevisionId: version.id,
    }).unwrap();
    onRollbackComplete?.();
  };

  return (
    <VersionHistoryPopover
      versions={versions}
      isLoading={isLoading}
      isRollingBack={isRollingBack}
      isDisabled={isDisabled}
      getLabel={(version) => version.identity.name}
      onRollback={handleRollback}
      restoreTargetDescription="your current live configuration"
    />
  );
};
